<template>
  <div class="Header">
    <div class="header-left">
      <img src="../assets/top_logo.png" />
    </div>

    <div class="header-right">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        v-for="(item, index) in menuList" :key="index"
      >
        <el-submenu :index="item.id" v-if="item.children">
          <template slot="title">
            <router-link :to="item.path">{{item.name}}</router-link>
          </template>
          <el-menu-item :index="items.id" v-for="(items, i) in item.children" :key="i">
            <router-link :to="{path: items.path, query: {tabid: i}}" tag="div">
              {{items.name}}
            </router-link>
          </el-menu-item>
        </el-submenu> 

        <el-menu-item :index="item.id" v-else>
          <router-link :to="item.path">{{item.name}}</router-link>
        </el-menu-item>
      </el-menu>
    </div>

  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String,
    svbactiveIndex: '',
    svbactiveabout: '',
  },
  data() {
    return {
      activeIndex: '0',
      index: '',
      menuList: [
        {
          id: '0',
          name: "首页",
          path: "/" 
        },
        {
          id: '1',
          name: "关于弘瀚",
          path: "/About" ,
          children: [
            {
              id: "1-1",
              name: "公司简介",
              path: "/About",
              active: true,
            },
            {
              id: "1-2",
              name: "公司荣誉",
              path: "/About",
              active: true,
            },
            // {
            //   id: "1-3",
            //   name: "企业文化",
            //   path: "/About",
            //   active: true,
            // },
            {
              id: "1-3",
              name: "发展历程",
              path: "/About",
              active: true,
            },
          ],
        },
        {
          id: '2',
          name: "产品中心",
          path: "/Product" ,
          // children: [
          //   {
          //     id: "2-1",
          //     name: "2222222222222222222222",
          //     path: "/customerList",
          //     active: true,
          //   },
          // ],
        },
        {
          id: '3',
          name: "行业案例",
          path: "/IndustryCase" ,
          // children: [
          //   {
          //     id: "3-1",
          //     name: "333333333333",
          //     path: "/customerList",
          //     active: true,
          //   },
          // ],
        },
        {
          id: '4',
          name: "行业动态",
          path: "/News" 
        },
        {
          id: '5',
          name: "联系我们",
          path: "/ContactUs" 
        },
      ],




    };
  },
  mounted(){
    const that = this;
    var needpath = that.$route.path;

    if(typeof that.svbactiveIndex === 'undefined' ){
        for(var i=0;i<that.menuList.length;i++){
          if(that.menuList[i].path == needpath){
            if(that.menuList[i].children){
              that.activeIndex = that.menuList[i].children[0].id;
            }else{
              that.activeIndex = that.menuList[i].id;
            }
          }
        }
      }else{
        const needactive = String(that.svbactiveIndex);
        that.activeIndex = needactive;
      }
    
    if(that.svbactiveabout == 1){
      that.activeIndex = '1-' + that.svbactiveabout;
    }
      

  },
  methods: {
  




  }


};
</script>

<style scoped>
.Header {
  display: flex;
  justify-content: space-between;
  height: 100px;
  width: 70.83%; /* 1360px */
  margin: 0 auto;
}

.header-left{
  width: 18.01%;
  display: flex;
  align-items: center;
}

.header-left img {
  width: 100%;
  
  margin-top: 5px;
  /* border: 1px solid red; */
}

.header-right {
  overflow: hidden;
  display: flex;
  align-items: center;
  height: 100px;
}

.header-right >>> .el-menu.el-menu--horizontal {
  border-bottom: 0;
}

.header-right >>> .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0;
}

.header-right a {
  text-decoration: none;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  line-height: 24px;
  color: #222222;
}

.header-right
  >>> .el-menu--horizontal
  > .el-submenu.is-active
  .el-submenu__title {
  border: 0;
  height: 100px;
  line-height: 100px;
}

.header-right >>> .el-menu--horizontal > .el-submenu .el-submenu__title {
  border: 0;
  height: 100px;
  line-height: 100px;
}

.header-right >>> .el-menu--horizontal > .el-menu-item {
  border: 0;
  height: 100px;
  line-height: 100px;
}

.header-right >>> .el-submenu__title {
  padding: 0 10px;
  color: #222222;
}

.header-right >>> .el-menu-item {
  padding: 0 10px;
  color: #222222;
}

.header-right >>> .el-submenu__title a:hover {
  color: #ffc200;
}

.header-right >>> .el-menu-item a:hover {
  color: #ffc200;
}

.header-right >>> .el-menu {
  height: 100px;
  background-color: #fff;
}

.header-right >>> .el-menu-item {
  border: 1px solid red;
}

.header-right >>> .is-active a {
  color: #ffc200;
}

.header-right >>> .el-menu-demo  > .el-menu-item{
  padding: 0 25px;
}

@media (max-width: 1199px){ 
  .header-right >>> .el-menu-demo  > .el-menu-item{
    padding: 0 12px;
  }
 }

.el-menu--horizontal .el-menu--popup .el-menu-item a{
  text-decoration: none;
  color: #999;
}

.el-menu--horizontal .el-menu--popup .el-menu-item:hover a{
  color: #ffc200;
}


</style>



// WEBPACK FOOTER //
// src/components/Header.vue